import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
import { Camera } from '@ionic-native/camera';
import { SettingsProvider } from './../../providers/settings/settings';
import { MediaCapture, MediaFile, CaptureError, CaptureVideoOptions } from '@ionic-native/media-capture';
import { File } from '@ionic-native/file';
import { Storage } from '@ionic/storage';


declare var window: any;
declare var LocalFileSystem: any;
const MEDIA_FILES_KEY = 'mediaFiles';


@Injectable()
export class VideoCameraProvider {
  videoData: any = null;
  mediaFiles: any = [];
  constructor(public http: Http, private storage: Storage, public file: File, public mediaCapture: MediaCapture, public settingsProvider: SettingsProvider, public camera: Camera) {
  }


  captureVideo() {
    let options: CaptureVideoOptions = {
      limit: 1,
    }
    this.mediaCapture.captureVideo(options).then((res: MediaFile[]) => {
      let capturedFile = res[0];
      let fileName = capturedFile.name;
      let dir = capturedFile['localURL'].split('/');
      dir.pop();
      let fromDirectory = dir.join('/');
      var toDirectory = this.file.dataDirectory;

      this.file.copyFile(fromDirectory, fileName, toDirectory, fileName).then((res) => {
        this.storeMediaFiles([{ name: fileName, size: capturedFile.size }]);
      }, err => {

      });
    },
      (err: CaptureError) => console.error(err));
  }


  takePicture(camera) {
    let self = this;
    this.camera.getPicture({
      quality: 50, // between 0-100 (default: 50)
      targetWidth: 600,
      targetHeight: 600,
      destinationType: 2, // 0- DATA_URL, 1- FILE_URL, 2 NATIVE_URL
      encodingType: 0, // 0- JPEG, 1- PNG
      mediaType: 1, // 0- Picture, 1- Video, 2- All Media
      sourceType: 2, // 0- Photolibrary, 1- Camera, 2- Saved Photolibrary
      correctOrientation: true
    }).then((fileEntry: any) => {
      let fileName = "consectus-goal-" + new Date().getTime() + ".jpg";
      self.moveFile(fileEntry, fileName);
    }).catch((error) => {
    });
  }

  moveFolderFile(fileEntry, fileName, folderName) {
    return new Promise(function (resolve, reject) {
      window.resolveLocalFileSystemURL(fileEntry,
        (entry) => {
          window.requestFileSystem(LocalFileSystem.PERSISTENT, 0, function (fileSys) {
            //The folder is created if doesn't exist
            fileSys.root.getDirectory(folderName,
              { create: true, exclusive: false },
              function (directory) {
                entry.moveTo(directory, fileName,
                  (entry) => {

                    resolve(entry.toURL());
                  },
                  (error) => {
                    
                    reject(error);
                  });
              },
              (error) => {
                
                reject(error);
              });
          },
            (error) => {
              
              reject(error);
            });
        },
        (error) => {
          
          reject(error);
        }
      );
    });
  }

  moveFile(fileEntry, fileName) {
    let self = this;
    self.moveFolderFile(fileEntry, fileName, "consectus")
      .then((url: string) => {
        
        url = url.replace(/^file:\/\//, ''); // remove the protocol from url to make it work on iOS
        return url;
      })
      .catch((error) => {
      });
  }

  storeMediaFiles(files) {
    this.storage.get(MEDIA_FILES_KEY).then(res => {
      if (res) {
        let arr = JSON.parse(res);
        arr = arr.concat(files);
        this.storage.set(MEDIA_FILES_KEY, JSON.stringify(arr));
      } else {
        this.storage.set(MEDIA_FILES_KEY, JSON.stringify(files))
      }
      this.mediaFiles = this.mediaFiles.concat(files);
    })
  }





}



// WEBPACK FOOTER //
// ./src/providers/video-camera/video-camera.ts